import { render, staticRenderFns } from "./verChatVigentes.vue?vue&type=template&id=0904b768&scoped=true&"
import script from "./verChatVigentes.vue?vue&type=script&lang=js&"
export * from "./verChatVigentes.vue?vue&type=script&lang=js&"
import style0 from "./verChatVigentes.vue?vue&type=style&index=0&id=0904b768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904b768",
  null
  
)

export default component.exports